<template>
  <v-layout row wrap align-content-start fill-height class="pa-4">
    <v-flex xs12 class="page-head-container mb-3">
      <v-flex xs12 class="mb-4 page-head-container">
        <h1 class="headline font-weight-light">Landmark List</h1>
      </v-flex>

      <v-flex xs12 class="search-container">
        <v-text-field
          label="Search"
          solo
          flat
          hide-details
          v-model="search"
        ></v-text-field>
      </v-flex>

      <v-flex xs12> 
        <template>
          <v-data-table
            v-if="getLandmarks.length > 0"
            :headers="headers"
            :items="getLandmarks"
            :pagination.sync="pagination"
            :search="search"
            hide-actions
            class="my-4"
          :disable-initial-sort=true >


            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in headers"
                  :key="header.text"
                  :class="['column sortable', pagination.order ? 'desc' : 'asc', header.value === pagination.title ? 'active' : '']"
                  @click="changeSort(header.value)"
                >
                  <v-icon small>arrow_upward</v-icon>
                  {{ header.text }}
                </th>
              </tr>
            </template>

            <template slot="items" slot-scope="props">
              <tr @click="clickItem(props.item)">
                <td>
                  <v-edit-dialog
                    :return-value.sync="props.item.landmark"
                    lazy
                    @save="updateLandmark(props.item.id, 'landmark', tempItem.landmark)"
                  > {{ props.item.landmark }}
                    <v-text-field
                      slot="input"
                      v-model="tempItem.landmark"
                      label="Edit"
                      single-line
                    ></v-text-field>
                  </v-edit-dialog>
                </td>
                <td>
                  <v-select
                    :items="getExaminationTypesListFormat"
                    v-model="props.item.examination_typeID" 
                    @change="updateLandmark(props.item.id,'examination_typeID',$event)">
                  </v-select>
                </td>
              </tr>
            </template>
          </v-data-table>
        </template>
      </v-flex>
    </v-flex>

    <v-btn icon fixed bottom right fab color="primary" @click="addLandmark">
      <v-icon>add</v-icon>
    </v-btn>

    <v-snackbar
      v-model="snackbar"
      bottom
      :timeout="timeout"
      color="green"
    >
      New Landmark Added
    </v-snackbar>
  </v-layout>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  export default {
    name: 'AdminLandmarkList',
    data() {
      return {
        search: '',
        pagination: {
          rowsPerPage: -1,
          title:'',
          order:false
        },
        headers: [
          {
            text: 'Landmark',
            align: 'left',
            value: 'landmark',
            // sortable: false
          },
          {
            text: 'Examination Type',
            align: 'left',
            value: 'examination_typeID',
            sortable: false
          }
        ],
        snackbar: false,
        timeout: 3000,
        tempItem:'',
        tempValue:''
      }
    },

    computed: {
      ...mapGetters('landmarks', [
        'getLandmarks'
      ]),
      ...mapGetters('examinationTypes', ['getExaminationTypesListFormat'])
    },

    created () {
      this.fetchLandmarks(),
      this.fetchExaminationTypes()
    },

    methods: {
      ...mapActions('landmarks', [
        'fetchLandmarks'
      ]),
      ...mapActions('examinationTypes', ['fetchExaminationTypes']),
      changeSort (column) {
        if(column===''){return;}
        if (this.pagination.title === column) {
          this.pagination.order = !this.pagination.order
        } else {
          this.pagination.title = column
          this.pagination.order = false
        }
        this.$store.dispatch('landmarks/sortLandmark', {title:column,order:this.pagination.order})

      },
      

      updateLandmark ( landmarkID, field, value ) {
        // console.log(landmarkID,field,value)
        const updateObj = {
          landmarkID: landmarkID,
          field: field,
          value: value
        }
        
        this.$store.dispatch('landmarks/updateColumnById', updateObj)
      },

      async addLandmark () {
        try {
          await this.$store.dispatch('landmarks/addLandmark')
          this.snackbar = true
        } catch (e) {
          this.snackbar = false
        }
      },
      clickItem(data){
        this.tempItem = Object.assign({}, data);
      }
    }
  }
</script>

<style lang="scss">
</style>